<template>

    <AppHead title="Analytics" />

    <section class="px-4 xl:px-0 pb-24 pt-6 md:pt-0">
        <SectionHeading title="Analytics">
            <select class="rounded-lg border-transparent py-3">
                <option selected>Last 30 days</option>
<!--                 <option>Last 7 days</option>
                <option>This year</option> -->
            </select>
        </SectionHeading>

        <div class="bg-white rounded-xl p-6 pb-7 mb-8 break-inside-avoid">
            <div class="flex justify-between items-center w-full mb-6">
                <div class="text-xl font-medium">
                    Last 30 days
                </div>
                <div class="text-gray-600">
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"></path></svg>
                </div>
            </div>
            <div class="w-full h-80">
                <LineChart class="h-80" v-if="startsStreamsOverTime" v-bind="lineChartProps" />
                <div v-if="loading.startsStreamsOverTime" class="w-full h-full flex items-center justify-center">
                    <div class="w-full max-w-sm flex items-center justify-center">
                        <svg class="animate-spin h-5 w-5 text-gray-700" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                    </div>
                </div>
                <div v-if="!loading.startsStreamsOverTime && !startsStreamsOverTime" class="w-full h-full flex items-center justify-center">
                    <div class="w-full max-w-sm flex items-center justify-center">
                        <div class="flex flex-col items-center justify-center">
                            <svg class="w-8 h-8 mb-4 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg>
                            <div class="text-sm font-medium">
                                No activity, yet.
                            </div>
                            <div class="text-gray-700 text-sm text-center">
                                Start sharing your podcasts!
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="bg-white rounded-xl p-6 pb-7 mb-8 break-inside-avoid">
            <div class="flex justify-between items-center w-full mb-6">
                <div class="text-xl font-medium">
                    Stats
                </div>
                <div class="text-gray-600">
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"></path></svg>
                </div>
            </div>
            <div v-if="stats" class="grid grid-flow-col gap-4 h-16">
                <StatsCard v-for="item in stats" :item="item" />
            </div>
            <div v-if="loading.stats" class="w-full flex items-center justify-center h-16">
                <div class="w-full max-w-sm flex items-center justify-center">
                    <svg class="animate-spin h-5 w-5 text-gray-700" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                </div>
            </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-6 break-inside-avoid">
            <div class="w-full bg-white p-6 rounded-xl">
                <div class="flex justify-between items-center w-full mb-8">
                    <div class="text-xl font-medium">
                        Starts by time of day
                    </div>
                    <div class="text-gray-600">
                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"></path></svg>
                    </div>
                </div>
                <div v-if="timeOfDay">
                    <div class="space-y-1 mb-3">
                        <div v-for="(period, index) in timeOfDay" class="grid grid-cols-8 grid-rows-8 gap-1">
                            <div class="flex items-center text-sm text-gray-600">{{ index }}</div>
                            <div v-for="value in period" class="bg-regal-blue-100 h-7 rounded">
                                <div class="w-full h-full bg-regal-blue-700 rounded" :style="'opacity:' + value.percentage + '%'">
                                    <div class="flex items-center justify-center cursor-pointer font-medium transition duration-100 ease-out w-full h-full text-white text-xs opacity-0 hover:opacity-100">
                                        {{ value.count }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="grid grid-cols-8">
                        <div class="text-sm text-gray-600 text-center">

                        </div>
                        <div class="text-sm text-gray-600 text-center">
                            Mon
                        </div>
                        <div class="text-sm text-gray-600 text-center">
                            Tue
                        </div>
                        <div class="text-sm text-gray-600 text-center">
                            Wed
                        </div>
                        <div class="text-sm text-gray-600 text-center">
                            Thu
                        </div>
                        <div class="text-sm text-gray-600 text-center">
                            Fri
                        </div>
                        <div class="text-sm text-gray-600 text-center">
                            Sat
                        </div>
                        <div class="text-sm text-gray-600 text-center">
                            Sun
                        </div>
                    </div>
                </div>
                <div v-if="loading.timeOfDay" class="w-full h-[25.75rem] flex items-center justify-center">
                    <div class="w-full h-full max-w-sm flex items-center justify-center">
                        <svg class="animate-spin h-5 w-5 text-gray-700" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                    </div>
                </div>
            </div>
            <div class="w-full flex flex-col bg-white p-6 rounded-xl">
                <div class="flex justify-between items-center w-full mb-6">
                    <div class="text-xl font-medium">
                        Devices
                    </div>
                    <div class="text-gray-600">
                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"></path></svg>
                    </div>
                </div>
                <div v-if="devices">
                    <div class="flex w-full items-center justify-center flex-1 mb-6">
                        <div class="max-w-[60%]">
                            <DoughnutChart v-bind="doughnutChartProps" />
                        </div>
                    </div>
                    <div class="w-full flex justify-center">
                        <div class="flex space-x-6">
                            <div class="flex space-x-2 items-center text-sm text-gray-600">
                                <div class="w-4 h-2 bg-regal-blue-700 rounded-sm">

                                </div>
                                <div class="">
                                    Mobile
                                </div>
                            </div>
                            <div class="flex space-x-2 items-center text-sm text-gray-600">
                                <div class="w-4 h-2 bg-regal-blue-400 rounded-sm">

                                </div>
                                <div class="">
                                    Tablet
                                </div>
                            </div>
                            <div class="flex space-x-2 items-center text-sm text-gray-600">
                                <div class="w-4 h-2 bg-regal-blue-200 rounded-sm">

                                </div>
                                <div class="">
                                    Desktop
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="loading.devices" class="w-full h-64 flex items-center justify-center">
                    <div class="w-full h-full max-w-sm flex items-center justify-center">
                        <svg class="animate-spin h-5 w-5 text-gray-700" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                    </div>
                </div>
                <div v-if="!loading.devices && !devices" class="w-full h-full flex items-center justify-center">
                    <div class="w-full max-w-sm flex items-center justify-center">
                        <div class="flex flex-col items-center justify-center">
                            <svg class="w-8 h-8 mb-4 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z"></path><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z"></path></svg>
                            <div class="text-sm font-medium">
                                No device data, yet.
                            </div>
                            <div class="text-gray-700 text-sm text-center">
                                Start sharing your podcasts!
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-6 break-inside-avoid mt-8">
            <div class="w-full bg-white p-6 rounded-xl">
                <div class="flex justify-between items-center w-full mb-8">
                    <div class="text-xl font-medium">
                        Countries
                    </div>
                    <div class="text-gray-600">
                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"></path></svg>
                    </div>
                </div>
                <div class="w-full">
                    <ol class="w-full text-sm font-medium max-h-64 overflow-y-scroll">
                        <template v-for="(count, country, index) in countries">
                        <li class="w-full even:bg-gray-200 flex justify-between items-center py-3 px-2.5 pr-3 rounded">
                            <div>{{ country }}</div>
                            <div>{{ count }}</div>
                        </li>
                        </template>
                    </ol>
                </div>
                <div v-if="loading.countries" class="w-full h-64 flex items-center justify-center">
                    <div class="w-full h-full max-w-sm flex items-center justify-center">
                        <svg class="animate-spin h-5 w-5 text-gray-700" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                    </div>
                </div>
                <div v-if="!loading.countries && !countries" class="w-full h-full flex items-center justify-center h-64">
                    <div class="w-full max-w-sm flex items-center justify-center">
                        <div class="flex flex-col items-center justify-center">
                            <svg class="w-8 h-8 mb-4 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z"></path><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z"></path></svg>
                            <div class="text-sm font-medium">
                                No country data, yet.
                            </div>
                            <div class="text-gray-700 text-sm text-center">
                                Start sharing your podcasts!
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="w-full bg-white p-6 rounded-xl">
                <div class="flex justify-between items-center w-full mb-8">
                    <div class="text-xl font-medium">
                        Browsers
                    </div>
                    <div class="text-gray-600">
                        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"></path></svg>
                    </div>
                </div>
                <div class="w-full">
                    <ol class="w-full text-sm font-medium max-h-64 overflow-y-scroll">
                        <template v-for="(count, browser, index) in browsers">
                        <li class="w-full even:bg-gray-200 flex justify-between items-center py-3 first:pt-0 last:pb-0 pr-2">
                            <div>{{ browser }}</div>
                            <div>{{ count }}</div>
                        </li>
                        </template>
                    </ol>
                </div>
                <div v-if="loading.browsers" class="w-full h-64 flex items-center justify-center">
                    <div class="w-full h-full max-w-sm flex items-center justify-center">
                        <svg class="animate-spin h-5 w-5 text-gray-700" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                    </div>
                </div>
                <div v-if="!loading.browsers && !browsers" class="w-full h-full flex items-center justify-center h-64">
                    <div class="w-full max-w-sm flex items-center justify-center">
                        <div class="flex flex-col items-center justify-center">
                            <svg class="w-8 h-8 mb-4 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z"></path><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z"></path></svg>
                            <div class="text-sm font-medium">
                                No browser data, yet.
                            </div>
                            <div class="text-gray-700 text-sm text-center">
                                Start sharing your podcasts!
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </section>
</template>

<script>
    import Layout from '@/Shared/Layout'
    import { useForm } from '@inertiajs/inertia-vue3'
    import SectionHeading from '@/Shared/SectionHeading'
    import StatsCard from '@/Shared/StatsCard'
    import { LineChart, useLineChart, DoughnutChart, useDoughnutChart } from 'vue-chart-3'
    import { Chart, registerables } from 'chart.js'
    import { ref, computed } from 'vue'
    import axios from 'axios'

    Chart.register(...registerables)

    export default {
        setup (props) {
            const loading = ref({
                startsStreamsOverTime: true,
                stats: true,
                timeOfDay: true,
                devices: true,
                countries: true,
                browsers: true,
            })

            const stats = ref(null)
            const startsStreamsOverTime = ref(null)
            const timeOfDay = ref(null)
            const devices = ref(null)
            const countries = ref(null)
            const browsers = ref(null)

            const chartData = computed(() => ({
                labels: startsStreamsOverTime.value ? startsStreamsOverTime.value.labels : null,
                datasets: [
                    {
                        label: 'Streams',
                        data: startsStreamsOverTime.value ? startsStreamsOverTime.value.datasets.data.streams : null,
                        fill: false,
                        borderColor: '#433edb',
                        borderCapStyle: 'round',
                        tension: 0.2,
                        pointRadius: 8,
                        borderJoinStyle: 'round',
                        borderWidth: 2.5,
                        // cubicInterpolationMode: 'monotone',
                        pointBorderColor: 'rgba(0, 0, 0, 0)',
                        pointBackgroundColor: 'rgba(0,0,0,0)'
                    },
                    {
                        label: 'Starts',
                        data: startsStreamsOverTime.value ? startsStreamsOverTime.value.datasets.data.starts : null,
                        fill: false,
                        borderColor: '#9cb1fb',
                        borderCapStyle: 'square',
                        tension: 0.2,
                        pointRadius: 8,
                        borderJoinStyle: 'round',
                        borderWidth: 2.5,
                        borderDash: [2, 6],
                        // cubicInterpolationMode: 'monotone',
                        pointBorderColor: 'rgba(0, 0, 0, 0)',
                        pointBackgroundColor: 'rgba(0,0,0,0)'
                    },
                ],
            }))

            const doughnutChartData = computed(() => ({
                labels: devices.value ? devices.value.labels : null,
                datasets: [
                    {
                        label: 'Activty by device',
                        data: devices.value ? devices.value.datasets.data : null,
                        backgroundColor: [
                            '#433edb',
                            '#7c8cf8',
                            '#c1d5fd'
                        ],
                    },
                ],
            }))

            const doughnutChartOptions = {
                plugins: {
                    legend: {
                        position: 'bottom',
                        display: false,
                        labels: {
                            color: '#b1b2b5',
                            font: {
                                family: 'Inter, system-ui, sans-serif',
                                size: 14,
                            },
                        }
                    }
                },
            }

            const { doughnutChartProps, doughtnutChartRef } = useDoughnutChart({
                chartData: doughnutChartData,
                options: doughnutChartOptions
            })

            const options = {
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        display: false,
                    }
                },
                scales: {
                    x: {
                        grid: {
                            display: false
                        },
                        ticks: {
                            color: '#b1b2b5',
                            font: {
                                family: 'Inter, system-ui, sans-serif',
                                size: 14,
                            },
                            autoSkip: true,
                            maxRotation: 0,
                            maxTicksLimit: 5
                        },
                    },
                    y: {
                        grid: {
                            display: false
                        },
                        ticks: {
                            color: '#b1b2b5',
                            font: {
                                family: 'Inter, system-ui, sans-serif',
                                size: 14,
                            },
                            stepSize: 1,
                            maxTicksLimit: 10,
                            autoSkip: true,
                        },
                    }

                },
            }

            const { lineChartProps, lineChartRef } = useLineChart({
                chartData: chartData,
                options: options,
            })

            return { lineChartProps, lineChartRef, chartData, doughtnutChartRef, doughnutChartProps, loading, stats, startsStreamsOverTime, timeOfDay, devices, countries, browsers }
        },
        mounted() {
            this.getStartsStreamsOverTime()
            this.getStats()
            this.getDevices()
            this.getLocations()
            this.getBrowsers()
            setTimeout(() => {this.getTimeOfDay()}, 150);
        },
        methods: {
            getStartsStreamsOverTime() {
                axios.get(route('analytics.get', 'startsStreamsOverTime'))
                    .then(res => {
                        this.startsStreamsOverTime = res.data
                        this.loading.startsStreamsOverTime = false
                    })
            },
            getStats() {
                axios.get(route('analytics.get', 'stats'))
                    .then(res => {
                        this.stats = res.data
                        this.loading.stats = false
                    })
            },
            getTimeOfDay() {
                axios.get(route('analytics.get', 'timeOfDay'))
                    .then(res => {
                        this.timeOfDay = res.data
                        this.loading.timeOfDay = false
                    })
            },
            getDevices() {
                axios.get(route('analytics.get', 'devices'))
                    .then(res => {
                        this.devices = res.data
                        this.loading.devices = false
                    })
            },
            getLocations() {
                axios.get(route('analytics.get', 'locations'))
                    .then(res => {
                        this.countries = res.data
                        this.loading.countries = false
                    })
            },
            getBrowsers() {
                axios.get(route('analytics.get', 'browsers'))
                    .then(res => {
                        this.browsers = res.data
                        this.loading.browsers = false
                    })
            }
        },
        components: { SectionHeading, StatsCard, LineChart, DoughnutChart },
        props: {
        },
        layout: Layout,
    }
</script>
